<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white"> Please Wait...</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Admin User

        <button mat-raised-button color="primary" style="font-size: 14px;
                    margin-right: 15px;" (click)="AddAdminUser()"><mat-icon>add</mat-icon>Add</button>
    </div>
</div>

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID. </th>
                <td mat-cell *matCellDef="let element"> {{element.srNo}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="mobile">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Mobile </th>
                <td mat-cell *matCellDef="let element"> {{element.mobile}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                <td mat-cell *matCellDef="let element"> {{element.role}} </td>
            </ng-container>

            <ng-container matColumnDef="user_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
                <td mat-cell *matCellDef="let element"> {{element.user_name}} </td>
            </ng-container>
            <!-- <ng-container matColumnDef="user_pwd">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Password</th>
                <td mat-cell *matCellDef="let element"> {{element.user_pwd}} </td>
            </ng-container> -->
            <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
                <td mat-cell *matCellDef="let element"> {{element.created_by}} </td>
            </ng-container>

            <ng-container matColumnDef="is_active">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
                <td mat-cell *matCellDef="let element" [hidden]="element.role == 'admin'"> <mat-checkbox [(ngModel)]="element.is_active"
                        (change)="onCheckboxChange(element)">
                    </mat-checkbox></td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="warn" aria-label="Example icon button with a delete icon"
                        [hidden]="element.role == 'admin'" style="margin-left: 5px;" (click)="DeleteAdmin(element.id)"
                        matTooltip="Delete">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>